import { Address } from 'pages/address/Address';
import FLSApiClient from '../common/FLSApiClient';
import { unFormatPostalCodeValue } from '../components/common/FieldFormat';

export const GetAddressFLS = (sessionId: string, id: number): Promise<Address[]> => {
  const formattedParams: { [key: string]: any } = {
    sessionId: sessionId,
    addressId: id,
  };
  return FLSApiClient.get(`/api/Profile/Address`, {
    params: formattedParams,
  }).then((response) => {
    return response.data.Addresses as Address[];
  });
};

export const UpsertAddressFLS = (addressInfo: Address, sessionId: string): Promise<any> => {
  return FLSApiClient({
    method: addressInfo.Id != undefined && addressInfo.Id > 0 ? 'PUT' : 'POST',
    url: '/api/Profile/Address',
    data: {
      AddressId: addressInfo.Id,
      Label: addressInfo.Label,
      Street: addressInfo.Street,
      CivicNumber: addressInfo.CivicNumber,
      Province: addressInfo.Province,
      City: addressInfo.City,
      Appartment: addressInfo.Appartment,
      PostalCode: unFormatPostalCodeValue(addressInfo.PostalCode),
      AddressType: addressInfo.IsPrimaryAddress ? 'Primary' : 'Secondary',
      Country: addressInfo.Country,
      FirstName: addressInfo.FirstName,
      LastName: addressInfo.LastName,
      Phone: addressInfo.AddressPhoneNumber,
      SessionId: sessionId,
    },
  });
};
